import { render } from "./BranchDot.vue?vue&type=template&id=5b4059c0"
import script from "./BranchDot.vue?vue&type=script&lang=js"
export * from "./BranchDot.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__